// extracted by css-extract-rspack-plugin
export default {"wrapper":"_7352a1da","column":"_67e8709f"};